module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "BookartSubmit pa2-m pa4-l"
  }, [_c('form', {
    ref: "form",
    staticClass: "mw7-ns center",
    attrs: {
      "method": "POST",
      "enctype": "multipart/form-data",
      "action": ((_vm.$root.BASE) + "/api/v1/submit")
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.submitForm($event)
      }
    }
  }, [_c('h3', [_vm._v("Submit your project")]), _c('p', {
    staticStyle: {
      "line-height": "1.5"
    }
  }, [_vm._v("This estimator is intended to provide you with a rough cost estimate. Once you submit your estimate, BookArt will contact you to discuss your project in more detail and provide you with a final quote.")]), _c('p', {
    staticClass: "small mb4"
  }, [_vm._v("* Indicates a required field.")]), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "HTMLSummary"
    },
    domProps: {
      "value": _vm.HTMLSummary
    }
  }), _c('div', {
    staticClass: "cf mb3"
  }, [_c('div', {
    staticClass: "fl w-50 pr2"
  }, [_c('label', {
    attrs: {
      "for": "firstname"
    }
  }, [_vm._v("First name *")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.model.firstname),
      expression: "model.firstname",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "name": "firstname"
    },
    domProps: {
      "value": (_vm.model.firstname)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "firstname", $event.target.value.trim())
      }, function($event) {
        return _vm.$v.model.firstname.$touch()
      }],
      "focusout": function($event) {
        return _vm.$v.model.firstname.$touch()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), (_vm.$v.model.firstname.$error && !_vm.$v.model.firstname.required) ? _c('div', {
    staticClass: "red f6 mt2"
  }, [_vm._v("Required")]) : _vm._e()]), _c('div', {
    staticClass: "fl w-50 pl2"
  }, [_c('label', {
    attrs: {
      "for": "lastname"
    }
  }, [_vm._v("Last name *")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.model.lastname),
      expression: "model.lastname",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "name": "lastname"
    },
    domProps: {
      "value": (_vm.model.lastname)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "lastname", $event.target.value.trim())
      }, function($event) {
        return _vm.$v.model.lastname.$touch()
      }],
      "focusout": function($event) {
        return _vm.$v.model.lastname.$touch()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), (_vm.$v.model.lastname.$error && !_vm.$v.model.lastname.required) ? _c('div', {
    staticClass: "red f6 mt2"
  }, [_vm._v("Required")]) : _vm._e()])]), _c('div', {
    staticClass: "mb3"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email *")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.model.email),
      expression: "model.email",
      modifiers: {
        "trim": true
      }
    }],
    staticStyle: {
      "max-width": "376px"
    },
    attrs: {
      "type": "email",
      "name": "email"
    },
    domProps: {
      "value": (_vm.model.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "email", $event.target.value.trim())
      }, function($event) {
        return _vm.$v.model.email.$touch()
      }],
      "focusout": function($event) {
        return _vm.$v.model.email.$touch()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), (_vm.$v.model.email.$error && !_vm.$v.model.email.required) ? _c('div', {
    staticClass: "red f6 mt2"
  }, [_vm._v("Required")]) : _vm._e(), (_vm.$v.model.email.$error && _vm.$v.model.email.required && !_vm.$v.model.email.email) ? _c('div', {
    staticClass: "red f6 mt2"
  }, [_vm._v("Please enter a valid email")]) : _vm._e()]), _c('div', {
    staticClass: "mb4"
  }, [_c('label', {
    attrs: {
      "for": "postal"
    }
  }, [_vm._v("Postal code")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.model.postal),
      expression: "model.postal",
      modifiers: {
        "trim": true
      }
    }],
    staticStyle: {
      "max-width": "127px"
    },
    attrs: {
      "type": "text",
      "name": "postal"
    },
    domProps: {
      "value": (_vm.model.postal)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "postal", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _c('div', {
    staticClass: "mb4"
  }, [_c('h3', {
    staticClass: "mb0"
  }, [_vm._v("Deadline")]), _c('p', {
    staticClass: "f6 lh-copy measure gray mt1"
  }, [_vm._v("Please select a project deadline—the date by which you wish to receive the books. Once we have received your submission, we will look over the project details and provide you with a timeline for book production.")]), _c('datepicker', {
    attrs: {
      "name": "deadline",
      "disabled": _vm.disabledDates,
      "inline": true
    },
    model: {
      value: (_vm.model.deadline),
      callback: function($$v) {
        _vm.$set(_vm.model, "deadline", $$v)
      },
      expression: "model.deadline"
    }
  })], 1), (_vm.settings.showDesignFilesUpload) ? _c('div', {
    staticClass: "mb4"
  }, [_c('h3', {
    staticClass: "mb0"
  }, [_vm._v("Design Files")]), _c('p', {
    staticClass: "f6 lh-copy measure gray mt1"
  }, [_vm._v("If you have your book already designed please provide a low-res PDF. This will help us provide the most accurate estimate. (File must be less than 25MB)")]), _c('input', {
    ref: "filePicker",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "name": "filepicker",
      "type": "file",
      "multiple": "",
      "accept": ".pdf"
    },
    on: {
      "change": function($event) {
        return _vm.filePickerChange($event)
      }
    }
  }), _c('a', {
    staticClass: "dib f6 no-underline tc bg-near-black white bg-animate hover-bg-dark-gray pv3 ph4 ttu tracked",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openFilePicker.apply(null, arguments)
      }
    }
  }, [_vm._v("Upload PDFs")]), (_vm.designFiles.length > 0) ? _c('ul', {
    staticClass: "Filelist"
  }, _vm._l((_vm.designFiles), function(designFile) {
    return _c('li', [_vm._v(_vm._s(designFile.filename) + " (" + _vm._s(designFile.size) + ")")])
  }), 0) : _vm._e()]) : _vm._e(), _c('div', {
    staticClass: "mb4"
  }, [_c('h3', {
    staticClass: "mb0"
  }, [_vm._v("Copy edit required?")]), _c('p', {
    staticClass: "f6 lh-copy measure gray mt1"
  }, [_vm._v("Most book submissions contain more errors—often many more—than clients imagine. However, a solid copy edit can protect your credibility and enhance your text by ensuring consistency in regard to spelling, grammar, punctuation, style, page numbering, format issues, and more. Our team of professional copy editors can help.")]), _c('p', {
    staticClass: "small mb4"
  }, [_vm._v("* Billed separately.")]), _c('div', [_c('div', {
    staticClass: "Radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.copyediting),
      expression: "model.copyediting"
    }],
    attrs: {
      "id": "copyediting-yes",
      "type": "radio",
      "name": "copyediting",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.model.copyediting, "1")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.model, "copyediting", "1")
      }
    }
  }), _c('label', {
    attrs: {
      "for": "copyediting-yes"
    }
  }, [_vm._v("Yes")])]), _c('div', {
    staticClass: "Radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.copyediting),
      expression: "model.copyediting"
    }],
    attrs: {
      "id": "copyediting-no",
      "type": "radio",
      "name": "copyediting",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.model.copyediting, "0")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.model, "copyediting", "0")
      }
    }
  }), _c('label', {
    attrs: {
      "for": "copyediting-no"
    }
  }, [_vm._v("No")])])])]), _c('div', {
    staticClass: "mb4"
  }, [_c('h3', {
    staticClass: "mb0"
  }, [_vm._v("Graphic design assistance required?")]), _c('p', {
    staticClass: "f6 lh-copy measure gray mt1"
  }, [_vm._v("Attractive, consistent graphic design is a key component of a solid publication. We offer a full range of design services, from image editing, to typography and layout, to polishing your final book design. Let us help you enhance your graphics and tighten up your book’s overall look.")]), _c('p', {
    staticClass: "small mb4"
  }, [_vm._v("* Billed separately.")]), _c('div', [_c('div', {
    staticClass: "Radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.designassistance),
      expression: "model.designassistance"
    }],
    attrs: {
      "id": "designassistance-yes",
      "type": "radio",
      "name": "designassistance",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.model.designassistance, "1")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.model, "designassistance", "1")
      }
    }
  }), _c('label', {
    attrs: {
      "for": "designassistance-yes"
    }
  }, [_vm._v("Yes")])]), _c('div', {
    staticClass: "Radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.designassistance),
      expression: "model.designassistance"
    }],
    attrs: {
      "id": "designassistance-no",
      "type": "radio",
      "name": "designassistance",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.model.designassistance, "0")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.model, "designassistance", "0")
      }
    }
  }), _c('label', {
    attrs: {
      "for": "designassistance-no"
    }
  }, [_vm._v("No")])])])]), _c('div', {
    staticClass: "mb4"
  }, [_c('h3', {
    staticClass: "mb0"
  }, [_vm._v("Prepress assistance required?")]), _c('p', {
    staticClass: "f6 lh-copy measure gray mt1"
  }, [_vm._v("So, your book design is complete—but have you prepared the files for print? Bad prepress can result in formatting problems, color distortions, and other inconsistencies. Get the drop on these issues—let us set up your files for proper binding type, ensure the best possible color reproduction, and troubleshoot all your problems before the ink hits the paper.")]), _c('div', [_c('div', {
    staticClass: "Radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.prepressassistance),
      expression: "model.prepressassistance"
    }],
    attrs: {
      "id": "prepressassistance-yes",
      "type": "radio",
      "name": "prepressassistance",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.model.prepressassistance, "1")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.model, "prepressassistance", "1")
      }
    }
  }), _c('label', {
    attrs: {
      "for": "prepressassistance-yes"
    }
  }, [_vm._v("Yes")])]), _c('div', {
    staticClass: "Radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.prepressassistance),
      expression: "model.prepressassistance"
    }],
    attrs: {
      "id": "prepressassistance-no",
      "type": "radio",
      "name": "prepressassistance",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.model.prepressassistance, "0")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.model, "prepressassistance", "0")
      }
    }
  }), _c('label', {
    attrs: {
      "for": "prepressassistance-no"
    }
  }, [_vm._v("No")])])])]), _c('div', {
    staticClass: "mb4"
  }, [_c('h3', {
    staticClass: "mb0"
  }, [_vm._v("Comments and requests")]), _c('p', {
    staticClass: "f6 lh-copy measure gray mt1"
  }, [_vm._v("Please tell us about custom requests or any other important information. This may include custom sizing, finishing techniques, specialty paper choices, or anything you think we ought to know about your book.")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.comments),
      expression: "model.comments"
    }],
    attrs: {
      "name": "comments",
      "rows": "5",
      "placeholder": "Enter your comments and requests here"
    },
    domProps: {
      "value": (_vm.model.comments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "comments", $event.target.value)
      }
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-22899b66!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BookartSubmit/BookartSubmit.vue
// module id = 187
// module chunks = 2